module.exports = __webpack_public_path__ + "img/loading_icon.763858ad.gif";